import { SVGAttributes } from 'react';

import { Svg } from '../common';

import { ICON_LIST } from './iconList';

export type IconType = keyof typeof ICON_LIST;

export interface IconProps extends SVGAttributes<SVGElement> {
  type: IconType;
  size?: number;
  color?: string;
  serviceName?: string;
}

export const Icon = ({ type, size, color, serviceName = 'common' }: IconProps) => {
  const iconSrc = ICON_LIST[type];
  const iconSize = size || 24;

  return <Svg src={iconSrc} width={iconSize} type={'icon'} height={iconSize} color={color} serviceName={serviceName} />;
};
